import { FETCH_WEEKLY_HOURS_SUCCESS } from '../../constants/ActionTypes'

const initialSettings = {}

export default (state = initialSettings, action) => {
  switch (action.type) {
    case FETCH_WEEKLY_HOURS_SUCCESS: {
      return { ...state, index: action.payload }
    }

    default:
      return state
  }
}
